<template>
  <v-layout row justify-center>
    <v-dialog v-model="loading" persistent content content-class="centered-dialog" class="pb-0">
      <v-container fill-height class="pt-4 mb-0">
        <v-layout column justify-center align-center>
          <v-progress-circular indeterminate :size="70" :width="7" color="primary"></v-progress-circular>
          <h3 class="mt-3">{{ mensagem }}</h3>
        </v-layout>
      </v-container>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  name: "NexomedLoadingDialog",
  props: {
    loading: Boolean,
  },
  data: () => ({
    mensagem: 'Carregando...',
  })
};
</script>

<style>
.dialog.centered-dialog,
.v-dialog.centered-dialog {
  background: whitesmoke;
  box-shadow: none;
  border-radius: 6px;
  width: auto;
  padding: 0.625rem;
  color: black;
}
</style>
